/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PostFaceToFaceKycRequestRequestBeneficialOwnersInner
 */
export interface PostFaceToFaceKycRequestRequestBeneficialOwnersInner {
    /**
     * 住所
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'address': string;
    /**
     * 実質的支配者タイプ
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'beneficialOwnerType': PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum;
    /**
     * 生年月日
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'birthday'?: string;
    /**
     * 法人との関係性
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'corporateRelationships'?: PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum;
    /**
     * 居住国
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'countryResidence'?: string;
    /**
     * 性別
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'gender'?: PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum;
    /**
     * 外国人PEPsに該当するか
     * @type {boolean}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
    /**
     * 氏名・法人名
     * @type {string}
     * @memberof PostFaceToFaceKycRequestRequestBeneficialOwnersInner
     */
    'name': string;
}

export const PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum = {
    corporation: 'CORPORATION',
    person: 'PERSON'
} as const;

export type PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum = typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum[keyof typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerBeneficialOwnerTypeEnum];
export const PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum = {
    businessExecutor: 'BUSINESS_EXECUTOR',
    hasControllingInfluenceOverBusinessActivity: 'HAS_CONTROLLING_INFLUENCE_OVER_BUSINESS_ACTIVITY',
    hasRightOver25Per: 'HAS_RIGHT_OVER_25PER',
    hasRightOver50Per: 'HAS_RIGHT_OVER_50PER'
} as const;

export type PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum = typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum[keyof typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerCorporateRelationshipsEnum];
export const PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum = {
    female: 'FEMALE',
    male: 'MALE'
} as const;

export type PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum = typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum[keyof typeof PostFaceToFaceKycRequestRequestBeneficialOwnersInnerGenderEnum];


